export class FileExtension {
  constructor(
    public extension: string,
    public description: string,
    public category = '') {
  }
}

export interface IFileUploadMetadata {
  fileSectionId: number;
  fileOriginId?: number;
}

